const EmailPerformanceWidget = ({ crmEmailId }) => {
  if (!crmEmailId) return null;

  return (
    <div className='py-3 pl-3 pr-3 mb-3 box-rounded box-outstanding-reports bg-white'>
      <h3 className='font-weight-bold'>Email performance</h3>
      <a
        className='w-100 d-block text-left specific-y-padding-6 px-3 border text-decoration-none general-button rounded-pill text-925 simple-link-button action-state-hover d-flex align-items-center'
        href={`/people/email-performance/${crmEmailId}`}
        target='_blank'
        rel='noreferrer'
      >
        <span
          className='icon-email paragraph-p3 d-inline-block specific-right-margin-11'
          style={{ marginLeft: '-2px', transform: 'translateY(1px)' }}
        />
        <span style={{ transform: 'translateY(1px)' }}>See email performance</span>
      </a>
    </div>
  );
};

export default EmailPerformanceWidget;
